import { Col, Divider, Row, Space, Typography } from 'antd'
import dayjs from 'dayjs'
import { D4_Fn_View_Evenements, Maybe } from '../../types'
import Thumbnail from '../Thumbnail'

const FileList = ({ evenements }: { evenements: Maybe<D4_Fn_View_Evenements[]> | undefined }) => {
  return (
    <>
      {evenements
        ?.filter((evt) => evt.fichier)
        .map((evt) => {
          return (
            <Row key={evt.id} gutter={[12, 12]}>
              <Col>
                <Space>
                  <Typography>
                    {evt.auteurprenom} {evt.auteurnom}
                  </Typography>
                  {dayjs(evt.dateevenement).format('DD/MM/YYYY HH:mm')}
                </Space>
                <Thumbnail texte={evt.texte} />
              </Col>
              <Divider />
            </Row>
          )
        })}
    </>
  )
}

export default FileList
